export const externalUserFallback = {
  userId: 51,
  email: 'usercore@agrosuper.com'
}

export const buildExternalUserHeaders = (userData) => ({
  'user-id': JSON.stringify(
    userData
      ? {
          userId: userData?.id,
          email: userData?.email
        }
      : externalUserFallback
  )
})
